var render, staticRenderFns
import script from "./view1.vue?vue&type=script&lang=js&"
export * from "./view1.vue?vue&type=script&lang=js&"
import style1 from "./view1.vue?vue&type=style&index=1&id=7a6fd092&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6fd092",
  null
  
)

export default component.exports